<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { useAlert } from 'dashboard/composables';
import ServiceSelectionTable from '../../../../components/ServiceSelectionTable.vue';

export default {
  name: "LinkServiceModal",

  components: {
    BaseModal,
    ServiceSelectionTable,
  },

  props: {
    services: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      initialSelectedIds: [],
      selectedServiceId: [],
      isConfirming: false,
      isAllLoading: false,
    };
  },

  computed: {
    branchId() {
      return this.$route.params.branchId;
    },
    staffId() {
      return this.$route.params.staffId;
    },
  },

  methods: {
    /** Pre-fill selection from parent */
    fetchExistingServices() {
      this.initialSelectedIds = this.services.map(s => s.id);
      this.selectedServiceId = [...this.initialSelectedIds];
    },

    /** Table emits selection here */
    handleSelection(ids) {
      this.selectedServiceId = ids;
    },

    async handleConfirm() {
      try {
        this.isConfirming = true;

        await this.$store.dispatch('serviceStaff/bulkAssignServicesToStaff', { 
          branch_id: this.branchId,
          staff_id: this.staffId,
          service_ids: this.selectedServiceId,
          update_mode: 'replace',
        });

        useAlert(`Services linked to branch`);
        this.$emit('refresh');
        this.$emit('close');

      } catch (err) {
        console.error(err);
        useAlert(`Failed to link branch to services: ${err}`);
      } finally {
        this.isConfirming = false;
      }
    },
  },

  async mounted() {
    this.isAllLoading = true;
    this.fetchExistingServices();
    this.isAllLoading = false;
  }
};
</script>

<template>
  <BaseModal size="large" @close="$emit('close')">
    <template #title>
      Link Branch Services
    </template>

    <ServiceSelectionTable
      :branchId="branchId"
      :initialSelectedIds="initialSelectedIds"
      @change="handleSelection"
    />

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button
          color-scheme="secondary"
          @click="$emit('close')"
          :disabled="isAllLoading"
        >
          Cancel
        </woot-button>

        <woot-button
          @click="handleConfirm"
          :is-loading="isConfirming"
          :disabled="isAllLoading"
        >
          Link
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>
